import { apiRequest } from './client.js';

export interface AdminUserItem {
  id: string;
  email: string;
  /** El backend puede devolver 'super_admin'; la UI lo trata como read-only. */
  role: 'auditor' | 'admin' | 'super_admin';
  is_active: boolean;
  mfa_configured: boolean;
  last_login_at: string | null;
  created_at: string;
}

export interface AdminUserCreated extends AdminUserItem {
  temp_password: string;
}

export const adminUsersApi = {
  list: () => apiRequest<{ users: AdminUserItem[] }>('/api/v1/admin/users'),
  create: (input: { email: string; role?: 'auditor' | 'admin' }) =>
    apiRequest<AdminUserCreated>('/api/v1/admin/users', { method: 'POST', body: input }),
  update: (id: string, input: { is_active?: boolean; role?: 'auditor' | 'admin' }) =>
    apiRequest<AdminUserItem>(`/api/v1/admin/users/${id}`, { method: 'PATCH', body: input }),
  resetMfa: (id: string) =>
    apiRequest<void>(`/api/v1/admin/users/${id}/reset-mfa`, { method: 'POST' }),
};
